const lead = {
    computed: {
        lead: {
            get(){
                return this.$store.state.lead.lead
            },
            set(payload){
                this.$store.commit('lead/setLead',payload)
            }
        },
        validation: {
            get(){
                return this.$store.state.lead.validation
            },
            set(payload){
                this.$store.commit('lead/setValidation',payload)
            }
        }
    },
    methods:{
        validate(){
            
            const requiredService = [
                'services_val',
                'dealer_id',
                'visit_hour_val'
            ];

            this.validation.service = requiredService.every((e) => {
                return !!this.lead[e];
            });

            const requiredClient = [
                'email',
                'last_name',
                'first_name',
                'phone_number',
                'accept1_val'
            ];

            const requiredVisit = [
                'hour',
                'date'
            ];

            this.validation.visit = requiredVisit.every((e) => {
                return !!this.lead[e];
            });
        


            this.validation.client = requiredClient.every((e) => {
                return !!this.lead[e];
            });

            const requiredCar = [
                'model_id',
                'registration_number',
                'vin',
                'mileage'
            ];

            this.validation.car = requiredCar.every((e) => {
                return !!this.lead[e];
            });
        



        },
        getDayofWeek(date){
            var r = new Date(Date.parse(date));
            console.log(r.getDay());
            return r.getDay();
        }
    },
    watch:{
        lead: {
            handler() {
                this.validate()
            },
            deep:true
        }
    }
}

export default lead;